import styled from 'styled-components';

import { Box, FlexBox, system, SystemProps } from '@sternum/styled-system';
import { Text12 } from '@sternum/ui';
import { Colors } from '@sternum/web/components/theme/constants';
import { ct } from '@sternum/web/utils/theme';

export const TimelinePointSelected = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90%;
  height: 90%;
  border-color: ${ct({ Dark: Colors.BrandBlueLight, Light: Colors.BrandBlueLight })};
  border-radius: 1000px;
  border-style: solid;
  background-color: ${ct({ Dark: Colors.BrandBlueLightest, Light: Colors.BrandBlueLightest })};
  z-index: -1;

  transition: width 0.2s ease-in-out, height 0.2s ease-in-out;
`;

export const TimePointContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
  background-color: inherit;
  border-radius: inherit;
`;

export const TimePointStyled = styled(FlexBox)<SystemProps>`
  position: relative;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  color: ${ct({ Dark: Colors.White, Light: Colors.White })};
  border-radius: 1000px;
  font-size: 10px;
  font-weight: 700;
  cursor: pointer;
  z-index: 1;

  &:before {
    content: '';
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    height: 100%;
    background-color: inherit;
    opacity: 40%;
    border-radius: 1000px;
    transition: width 0.2s ease-in-out, height 0.2s ease-in-out;
  }

  &:hover {
    &:before {
      width: calc(100% + 6px);
      height: calc(100% + 6px);
    }
  }

  &[aria-selected='true'] {
    ${TimelinePointSelected} {
      width: calc(100% + 8px);
      height: calc(100% + 8px);
      border-width: 1px;
    }
  }

  ${system};
`;

export const TimelinePointContainer = styled.div`
  display: flex;
  position: relative;
  padding-bottom: 20px;
`;

export const TimelineDetailsContainer = styled.div`
  display: flex;
  flex-flow: column;
  justify-content: center;
  padding-bottom: 20px;
`;

export const TimelineRowItem = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;

  &:last-child {
    ${TimelinePointContainer}, ${TimelineDetailsContainer} {
      padding-bottom: 0;
    }
  }
`;

export const TimelineGraphStyled = styled(FlexBox)<SystemProps>`
  display: flex;
  flex-flow: column;
  padding: 5px;

  ${system};
`;

export const Connector = styled(Box)`
  position: absolute;
  top: 34px;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 1px;
  z-index: 2;
`;

export const DetailTitle = styled(Text12)<{ color?: string }>`
  color: ${(props) => props.color || ct({ Dark: Colors.GreyDarker, Light: Colors.GreyDarker })};
`;

export const DetailValue = styled(Text12)`
  color: ${ct({ Dark: Colors.DarkerText, Light: Colors.DarkerText })};
  margin-left: 6px;
  word-break: break-word;
  flex: 1;
`;
